import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useAuth } from '../../context/AuthContext';
import './Auth.css';

const ROLE_HOME = { admin: '/admin', instructor: '/instructor', parent: '/dashboard' };

export default function ForceChangePasswordPage() {
  const { user, updateUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ new_password: '', confirm_password: '' });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    setError('');
    if (form.new_password !== form.confirm_password) {
      setError('Passwords do not match.');
      return;
    }
    setLoading(true);
    try {
      await axios.post('/api/auth/set-password', { new_password: form.new_password });
      updateUser({ must_change_password: false });
      navigate(ROLE_HOME[user?.role] || '/');
    } catch (err) {
      setError(err.response?.data?.error || 'Failed to set password. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-branding">
        <div className="auth-branding-inner">
          <div className="auth-logo"><img src="/wf-logo.png" alt="Wow Factor Baseball" style={{ width:'192px', height:'192px', objectFit:'contain' }} /></div>
          <h1 className="auth-brand-name">WOW FACTOR</h1>
          <p className="auth-brand-sub">Baseball Training & Development</p>
          <div className="auth-brand-divider" />
          <p className="auth-brand-quote">"Elevating the game,<br />one session at a time."</p>
        </div>
      </div>
      <div className="auth-form-panel">
        <div className="auth-form-container">
          <div className="auth-form-header">
            <h2 className="auth-form-title">SET YOUR PASSWORD</h2>
            <p className="auth-form-subtitle">Welcome, {user?.first_name}! Your account was created with a temporary password. Please set a new password before continuing.</p>
          </div>
          <form onSubmit={handleSubmit} className="auth-form">
            {error && (
              <div className="auth-error-banner"><span>⚠</span> {error}</div>
            )}
            <div className="form-group">
              <label className="form-label">New Password</label>
              <input
                type="password"
                className="form-input"
                value={form.new_password}
                onChange={e => setForm(f => ({ ...f, new_password: e.target.value }))}
                required
                minLength={8}
                placeholder="Min 8 chars, 1 uppercase, 1 number"
                autoFocus
              />
            </div>
            <div className="form-group">
              <label className="form-label">Confirm New Password</label>
              <input
                type="password"
                className="form-input"
                value={form.confirm_password}
                onChange={e => setForm(f => ({ ...f, confirm_password: e.target.value }))}
                required
                minLength={8}
                placeholder="Re-enter your new password"
              />
            </div>
            <button type="submit" className="btn btn-primary auth-submit-btn" disabled={loading}>
              {loading ? 'Saving...' : 'Set Password & Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
